import React from 'react';
import { Provider } from 'react-redux';
import ErrorBoundary from '@react/shared-component/error';

import RootAppLayout from '@job-facets/components/RootLayout';
import Store from './redux/store';

function App() {
	return (
		<ErrorBoundary>
			<Provider store={Store}>
				<RootAppLayout />
			</Provider>
		</ErrorBoundary>
	);
}

export default App;
